import {Injectable} from '@angular/core';
import {environment} from './../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {StorageKeys} from 'src/app/shared-module-files/simpo.constant';

@Injectable({
  providedIn: 'root'
})
export class PaymentsService {

  constructor(
    private http: HttpClient,
    public dialog: MatDialog,
    private snackbar: MatSnackBar,
  ) {
  }


  //subscription apis

  getPlansBasedOnBusinessId(businessId) {
    return this.http.get(
      environment.baseUrl + `business/subscription/plan/business?businessId=${businessId}`
    )
  }

  subscribePlan(data: any) {
    const businessName = localStorage.getItem(StorageKeys.BUSINESS_NAME)
    return this.http.post(
      environment.baseUrl + `business/payment/cf/subscription?businessId=${data.businessId}&planId=${data.subscriptionId}&isMonthly=${data.isMonthly}&partnerId=${data.affiliatePartnerKey}&isDomainMapping=false&businessName=${businessName}`, data
    )
  }

  subscribeAutoPay(data:any){
    return this.http.post(
      environment.baseUrl+`business/v2/subscription/create/subscription`,data
    )
  }

  buyOneTimeDomain(businessId: string, isDomainMapping: boolean) {
    const businessName = localStorage.getItem(StorageKeys.BUSINESS_NAME)
    return this.http.post(
      environment.baseUrl + `business/payment/cf/subscription?businessId=${businessId}&isDomainMapping=${isDomainMapping}&businessName=${businessName}`, ''
    )
  }

  subscribedOrNot(businessId, payment) {
    return this.http.get(
      environment.baseUrl + `business/subscription/business?businessId=${businessId}&payments=${payment}`
    )
  }

  sendPaymentId(data) {
    return this.http.put(
      environment.baseUrl + `business/subscription/cf/business?paymentId=${data.paymentId}&status=${data.status}&isDomainMapping=${data.isDomainMapping}`, data
    )
  }

  updatePaymentStatus(id:any){
    return this.http.get(
      environment.baseUrl+`business/v2/subscription/cf/check/status?orderId=${id}`
    )
  }

  downloadPaymentInvoice(data) {
    return this.http.put(
      environment.baseUrl + `business/invoice/download?invoiceId=${data.invoiceId}&isSubscription=true`, data
    )
  }


  //open popup

  openDialog(componentName: any, height: any, width: any, dataModel: any) {
    return this.dialog.open(componentName, {
      width: width,
      height: height,
      data: dataModel,
      disableClose: true,
      maxWidth: '100vw'
    });
  }

  contactUs(data) {
    return this.http.post(
      environment.baseUrl + `business/contact/simpo`, data
    )
  }

  getDetailsByBusinessId(businessId: any) {
    return this.http.get(
      environment.baseUrl + `business/business/${businessId}`
    );
  }
}
